import React from "react";
import Featured from "./featured/featured";
import Products from "./products/products";

function Layout () {
    return (
    <>
    <Featured />
    <Products />
    </>
    )
}

export default Layout;